import checkIfCanDestroyCredential from './user_account_credentials/destroy/checkIfCanDestroy';
import checkIfCanResetCredential from './user_account_credentials/reset/checkIfCanReset';
import checkIfCanAddCredential from './user_account_credentials/add/checkIfCanAdd';
import checkIfCanDestroyUser from './user_account/destroy/checkIfCanDestroy';
import checkIfCanUpdateUser from './user_account/update/checkIfCanUpdate';
import checkIfCanAddUser from './user_account/add/checkIfCanAdd';
import checkIfCanUpdateUserRole from './user_account_roles/update/checkIfCanUpdate';
import checkIfCanAddSystemRole from './system_roles/add/checkIfCanAdd';
import checkIfCanUpdateSystemRole from './system_roles/update/checkIfCanUpdate';
import checkIfCanDestroySystemRole from './system_roles/destroy/checkIfCanDestroy';
import checkIfCanUpdateSystemCompany from './system_company/update/checkIfCanUpdate';
import checkIfCanDestroySystemCompany from './system_company/destroy/checkIfCanDestroy';
import checkIfCanAddSystemCompany from './system_company/add/checkIfCanAdd';
import store from '../../store';
export default function checkScopes(buttonName, route, action) {
  let scopes = store.getters.userScopes;
  let check = false;
  // CREDENTIALS
  if (action === 'deleteCredential') check = checkIfCanDestroyCredential();
  if (buttonName === 'ResetButton') check = checkIfCanResetCredential();
  if (action === 'createCredential') check = checkIfCanAddCredential();
  if (action === 'updateCredential') check = checkIfCanResetCredential();
  // USER
  if (action === 'deleteUser') check = checkIfCanDestroyUser();
  if (action === 'updateUser') check = checkIfCanUpdateUser();
  if (action === 'addUser') check = checkIfCanAddUser();
  // USER ROLE
  if (action === 'addRoleToUser') check = checkIfCanUpdateUserRole();
  if (action === 'removeRoleFromUser') check = checkIfCanUpdateUserRole();
  if (action === 'addScopesToRole') check = checkIfCanUpdateUserRole();
  if (action === 'removeScopesFromRole') check = checkIfCanUpdateUserRole();
  if (action === 'removeRole') check = checkIfCanUpdateUserRole();
  // SYSTEM ROLE
  if (action === 'addSystemRole') check = checkIfCanAddSystemRole();
  if (action === 'updateSystemRole') check = checkIfCanUpdateSystemRole();
  if (action === 'destroySystemRole') check = checkIfCanDestroySystemRole();
  // SYSTEM COMPANY
  if (action === 'addCompany') check = checkIfCanAddSystemCompany();
  if (action === 'destroyCompany') check = checkIfCanDestroySystemCompany();
  if (action === 'updateCompany') check = checkIfCanUpdateSystemCompany();

  if (action === 'listOwnCompany') check = scopes.includes('system_company_list_company');
  if (action === 'listOwnUser') check = scopes.includes('user_account_list_self');
  if (
    action === 'listSystemRoles' &&
    (scopes.includes('system_roles_list_company') || scopes.includes('system_roles_list_all'))
  )
    check = true;
  if (action === 'listSystemCompanies') check = scopes.includes('system_company_list_all');
  return check;
}
